// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

type SvgProps = {
    width: number;
    height: number;
}

const CompanySvg = (props: SvgProps) => (
    <svg
        width={props.width ? props.width.toString() : '527'}
        height={props.height ? props.height.toString() : '296'}
        viewBox='0 0 170 149'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M133.188 130.941C149.323 117.33 159.572 96.962 159.572 74.2C159.572 33.2205 126.352 0 85.372 0C44.3925 0 11.172 33.2205 11.172 74.2C11.172 96.962 21.4213 117.33 37.5565 130.941H133.188Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.08'
        />
        <path
            d='M166.523 71.0823L166.523 60.2208L28.3461 60.2208L28.3461 48.0117L8.14688 48.0117'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.24'
            strokeWidth='1.24706'
            strokeLinecap='round'
        />
        <path
            d='M97.2708 24.9121L97.2708 44.9461L77.6077 44.9461'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.24'
            strokeWidth='1.24706'
            strokeLinecap='round'
        />
        <ellipse
            cx='1.855'
            cy='1.855'
            rx='1.855'
            ry='1.855'
            transform='matrix(-1 -1.74846e-07 -1.74846e-07 1 168.475 69.8359)'
            fill='var(--center-channel-color)'
            fillOpacity='0.48'
        />
        <ellipse
            cx='1.855'
            cy='1.855'
            rx='1.855'
            ry='1.855'
            transform='matrix(-1 -1.74846e-07 -1.74846e-07 1 99.1262 21.1992)'
            fill='var(--center-channel-color)'
            fillOpacity='0.48'
        />
        <ellipse
            cx='1.855'
            cy='1.855'
            rx='1.855'
            ry='1.855'
            transform='matrix(-1 -1.74846e-07 -1.74846e-07 1 9.98633 46.1406)'
            fill='var(--center-channel-color)'
            fillOpacity='0.48'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M23.7352 82.3047H44.9352V130.94H28.7234V130.941H16.2529V130.939H7.52344V94.7217H19.994V105.071H23.7352V82.3047ZM144.7 82.3047H123.5V130.94H144.7V130.94H152.182V130.939H162.159V108.174H152.182V95.7568H144.7V82.3047Z'
            fill='var(--center-channel-bg)'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M23.7352 82.3047H44.9352V130.94H28.7234V130.941H16.2529V130.939H7.52344V94.7217H19.994V105.071H23.7352V82.3047ZM144.7 82.3047H123.5V130.94H144.7V130.94H152.182V130.939H162.159V108.174H152.182V95.7568H144.7V82.3047Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='43.0644'
            y='38.7563'
            width='44.8941'
            height='91.0353'
            fill='var(--center-channel-bg)'
            stroke='#3F4350'
            strokeWidth='1.24706'
            strokeLinejoin='round'
        />
        <rect
            x='43.0644'
            y='39.2817'
            width='44.8941'
            height='88.5412'
            fill='var(--center-channel-bg)'
            stroke='#3F4350'
            strokeWidth='1.24706'
            strokeLinejoin='round'
        />
        <rect
            x='39.947'
            y='127.199'
            width='89.7882'
            height='3.74118'
            fill='var(--center-channel-bg)'
        />
        <rect
            x='40.5706'
            y='127.823'
            width='88.5412'
            height='2.49412'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
            stroke='var(--center-channel-color)'
            strokeWidth='1.24706'
        />
        <rect
            x='40.5706'
            y='35.5415'
            width='49.8824'
            height='3.74118'
            fill='var(--center-channel-bg)'
            stroke='var(--center-channel-color)'
            strokeWidth='1.24706'
            strokeLinejoin='round'
        />
        <rect
            x='40.5706'
            y='35.5415'
            width='49.8824'
            height='3.74118'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
            stroke='var(--center-channel-color)'
            strokeWidth='1.24706'
            strokeLinejoin='round'
        />
        <rect
            x='49.2998'
            y='31.7993'
            width='31.1765'
            height='3.74118'
            fill='var(--center-channel-bg)'
            stroke='var(--center-channel-color)'
            strokeWidth='1.24706'
            strokeLinejoin='round'
        />
        <rect
            x='49.2998'
            y='31.7993'
            width='31.1765'
            height='3.74118'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
            stroke='var(--center-channel-color)'
            strokeWidth='1.24706'
            strokeLinejoin='round'
        />
        <rect
            x='49.9233'
            y='46.1406'
            width='31.1765'
            height='8.72941'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='49.9233'
            y='59.8594'
            width='31.1765'
            height='8.72941'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='49.9233'
            y='73.5762'
            width='31.1765'
            height='8.72941'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='67.3823'
            y='53.623'
            width='6.23529'
            height='73.5765'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='49.9233'
            y='87.2949'
            width='31.1765'
            height='8.72941'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='49.9233'
            y='101.012'
            width='31.1765'
            height='8.72941'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='59.8999'
            y='117.223'
            width='11.2235'
            height='9.97647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='71.7468'
            y='54.2466'
            width='58.6118'
            height='76.0706'
            fill='var(--center-channel-bg)'
            stroke='var(--center-channel-color)'
            strokeWidth='1.24706'
            strokeLinejoin='round'
        />
        <rect
            x='71.7468'
            y='54.2466'
            width='58.6118'
            height='76.0706'
            stroke='var(--center-channel-color)'
            strokeWidth='1.24706'
            strokeLinejoin='round'
        />
        <rect
            x='77.3586'
            y='59.8594'
            width='8.72941'
            height='9.97647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='102.3'
            y='59.8594'
            width='8.72941'
            height='9.97647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='114.771'
            y='59.8594'
            width='8.72941'
            height='9.97647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='89.8293'
            y='59.8594'
            width='8.72941'
            height='9.97647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='77.3586'
            y='73.5762'
            width='8.72941'
            height='9.97647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='102.3'
            y='73.5762'
            width='8.72941'
            height='9.97647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='114.771'
            y='73.5762'
            width='8.72941'
            height='9.97647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='89.8293'
            y='73.5762'
            width='8.72941'
            height='9.97647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='77.3586'
            y='87.2949'
            width='8.72941'
            height='9.97647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='102.3'
            y='87.2949'
            width='8.72941'
            height='9.97647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='114.771'
            y='87.2949'
            width='8.72941'
            height='9.97647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='89.8293'
            y='87.2949'
            width='8.72941'
            height='9.97647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='77.3586'
            y='101.012'
            width='8.72941'
            height='9.97647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='102.3'
            y='101.012'
            width='8.72941'
            height='9.97647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='114.771'
            y='101.012'
            width='8.72941'
            height='9.97647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='89.8293'
            y='101.012'
            width='8.72941'
            height='9.97647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='102.3'
            y='43.6465'
            width='14.9647'
            height='7.48235'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <line
            x1='7.52332'
            y1='130.318'
            x2='162.159'
            y2='130.318'
            stroke='var(--center-channel-color)'
            strokeWidth='1.24706'
        />
        <rect
            x='68.0059'
            y='50.5063'
            width='66.0941'
            height='3.74118'
            fill='var(--center-channel-bg)'
            stroke='#3F4350'
            strokeWidth='1.24706'
            strokeLinejoin='round'
        />
        <rect
            x='68.0059'
            y='50.5063'
            width='66.0941'
            height='3.74118'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
            stroke='var(--center-channel-color)'
            strokeWidth='1.24706'
            strokeLinejoin='round'
        />
        <rect
            x='96.688'
            y='115.352'
            width='8.72941'
            height='14.9647'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
            stroke='var(--center-channel-color)'
            strokeWidth='1.24706'
        />
        <rect
            x='69.8762'
            y='127.199'
            width='63.6'
            height='3.74118'
            fill='var(--center-channel-bg)'
        />
        <rect
            x='70.4998'
            y='127.823'
            width='62.353'
            height='2.49412'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
            stroke='var(--center-channel-color)'
            strokeWidth='1.24706'
        />
        <rect
            x='88.5823'
            y='124.705'
            width='26.1882'
            height='3.74118'
            fill='var(--center-channel-bg)'
        />
        <rect
            x='89.2058'
            y='125.329'
            width='24.9412'
            height='2.49412'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
            stroke='var(--center-channel-color)'
            strokeWidth='1.24706'
        />
    </svg>

);

export default CompanySvg;
